document.addEventListener("alpine:init", () => {
    Alpine.data("contactForm", () => ({
        visible: false,
        showForm: false,
        sendingContainer: null,
        successContainer: null,
        selectFields: null,
        init() {
            // Form sending and success

            this.sendingContainer = this.$el.querySelector(
                ".Contact__Form__sending"
            );
            this.successContainer = this.$el.querySelector(
                ".Contact__Form__success"
            );

            this.$el.querySelectorAll(".wpcf7-submit").forEach((button) => {
                button.addEventListener("click", () => {
                    this.sendingContainer.classList.remove("hidden");
                    this.sendingContainer.classList.add("flex");
                });
            });

            this.$el.querySelector(".wpcf7").addEventListener(
                "wpcf7invalid",
                (e) => {
                    this.sendingContainer.classList.add("hidden");
                    this.sendingContainer.classList.remove("flex");
                },
                false
            );

            this.$el.querySelector(".wpcf7").addEventListener(
                "wpcf7mailsent",
                (e) => {
                    this.sendingContainer.classList.add("hidden");
                    this.sendingContainer.classList.remove("flex");
                    this.successContainer.classList.add("flex");
                    this.successContainer.classList.remove("hidden");
                    pegasus.scroll(this.successContainer, 0, "scrollTo");
                },
                false
            );

            // Select fields

            this.selectfields = this.$el.querySelectorAll("select");
            pegasus.selectField(this.selectfields, {
                openOnHover: false,
                itemsToShow: 5,
                firstItemDisabled: true,
                classNames: {
                    outerWrapper: "",
                    selector:
                        "Form__Selector -no-cancel w-full cursor-pointer flex text-left relative focus:outline-none py-2 pr-1",
                    selectorOpen: "-open",
                    selectionList:
                        "Form__Selector-list w-full rounded-b-md -open",
                    listItem:
                        "select-none relative transition duration-300 py-4 px-6",
                    listItemFocus: "",
                },
            });
        },
    }));
});
